/* 
fiky-web
*/

import React from "react";
import Slider from "react-slick";

import ava01 from "../../../assets/images/ava-1.jpg";
import ava02 from "../../../assets/images/ava-2.jpg";
import ava03 from "../../../assets/images/ava-3.jpg";

import "../../../styles/slider.css";

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 3000,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <Slider {...settings}>
      <div>
        <p className="review__text">
          "Masyallah dengan adanya website al-muhayyat food, anak kost sangat terbantu dalam hal pemesanan
          makanan. Dimana awal harus ke warung untuk memesan, dengan adanya website ini bisa memesan secara
          online dari dalam kamar saja"
        </p>
        <div className=" slider__content d-flex align-items-center gap-3 ">
          <img src={ava01} alt="avatar" className=" rounded" />
          <h6>Bayu</h6>
        </div>
      </div>
      <div>
        <p className="review__text">
          "Keren sangat diapresiasi pembuat website ini, sangat membantu sekali untuk anak-anak kost
          yang lagi sakit akan tetapi pengen makan tanpa harus keluar rumah, sangat terbantu sekali"
        </p>
        <div className="slider__content d-flex align-items-center gap-3 ">
          <img src={ava03} alt="avatar" className=" rounded" />
          <h6>Nasroh</h6>
        </div>
      </div>
      <div>
        <p className="review__text">
          "Dengan adanya website ini, warung saya jadi rame pesanan yang masuk melalui whatsapp saya.
          keren sangat berterimakasih karena telah dibuatkan website ini"
        </p>
        <div className="slider__content d-flex align-items-center gap-3 ">
          <img src={ava02} alt="avatar" className=" rounded" />
          <h6>Icha</h6>
        </div>
      </div>
    </Slider>
  );
};

export default TestimonialSlider;

/* 
fiky-web
*/